__turbopack_context__.v({
  "eyebrow": "HostingServicesCardSection-module__hDXOkW__eyebrow",
  "heading": "HostingServicesCardSection-module__hDXOkW__heading",
  "section": "HostingServicesCardSection-module__hDXOkW__section",
  "title": "HostingServicesCardSection-module__hDXOkW__title",
});
